import AmazonRDSIcon from '../assets/amazon-rds-icon.svg';
import AmazonRedshiftIcon from '../assets/amazon-redshift-icon.svg';
import AnthologyIcon from '../assets/anthology-icon.svg';
import AmazonElasticsearchIcon from '../assets/aws-elastic-search-icon.svg';
import AmazonS3Icon from '../assets/aws-s3-icon.svg';
import AmazonSESConnectorIcon from '../assets/aws-ses-icon.svg';
import BlackboardIcon from '../assets/blackboard-icon.svg';
import BrightspaceValenceIcon from '../assets/brightspace-valence-icon.svg';
import CanvasIcon from '../assets/canvas-icon.svg';
import ColleagueIcon from '../assets/colleague-icon.svg';
import DataOperationBatchTaskIcon from '../assets/data-operation-batch-task-icon.svg';
import DataOperationDedupTaskIcon from '../assets/data-operation-dedup-task-icon.svg';
import DeleteIcon from '../assets/delete-command-icon.svg';
import DelimitedReaderFormatIcon from '../assets/delimited-reader-format-icon.svg';
import DelimitedWriterFormatIcon from '../assets/delimited-writer-format-icon.svg';
import DocusignIcon from '../assets/docusign-icon.svg';
import EdfiIcon from '../assets/edfi-icon.svg';
import EdreadyIcon from '../assets/edready-icon.svg';
import Element451Icon from '../assets/element451-icon.svg';
import EthosIcon from '../assets/ethos-icon.svg';
import ExcelReaderFormatIcon from '../assets/excel-reader-format-icon.svg';
import ExcelWriterFormatIcon from '../assets/excel-writer-format-icon.svg';
import ExecuteIcon from '../assets/execute-command-icon.svg';
import FileOperationAppendTaskIcon from '../assets/file-operation-append-task-icon.svg';
import FileOperationDeleteFileFromS3TaskIcon from '../assets/file-operation-delete-file-from-s3-task-icon.svg';
import FileOperationS3DirectoryListingIcon from '../assets/file-operation-s3-directory-listing-icon.svg';
import GoogleBigQueryIcon from '../assets/google-big-query-icon.svg';
import GoogleSpreadsheetIcon from '../assets/google-sheets-icon.svg';
import GraphqlIcon from '../assets/graphql-icon.svg';
import HttpIcon from '../assets/http-icon-icon.svg';
import HttpXmlIcon from '../assets/http-xml-icon.svg';
import InfosilemIcon from '../assets/infosilem-icon.svg';
import InsertIcon from '../assets/insert-command-icon.svg';
import InsertDatarameIcon from '../assets/insert-data-frame-icon.svg';
import JdbcIcon from '../assets/jdbc-icon.svg';
import JsonIcon from '../assets/json-icon.svg';
import JsonReaderFormatIcon from '../assets/json-reader-format-icon.svg';
import LeadSquaredIcon from '../assets/lead-squared-icon.svg';
import LearningStreamIcon from '../assets/learning-stream-icon.svg';
import LingkIcon from '../assets/lingk-icon.svg';
import LocalFileIcon from '../assets/local-file-icon.svg';
import LogIcon from '../assets/log-icon.svg';
import MicrosoftCosmosDbIcon from '../assets/microsoft-cosmos-db-icon.svg';
import MoodleIcon from '../assets/moodle-icon.svg';
import OdataIcon from '../assets/odata-icon.svg';
import PaycomIcon from '../assets/paycom-icon.svg';
import PeoplesoftIcon from '../assets/people-soft-icon.svg';
import PrintIcon from '../assets/print-command-icon.svg';
import PrintSchemaIcon from '../assets/print-schema-command-icon.svg';
import RefreshIcon from '../assets/refresh-command-icon.svg';
import SalesforceIcon from '../assets/salesforce-icon.svg';
import SelectIcon from '../assets/select-command-icon.svg';
import SelectDatarameIcon from '../assets/select-data-frame-icon.svg';
import SftpIcon from '../assets/sftp-icon.svg';
import SftpOperationCopyFileTaskIcon from '../assets/sftp-operation-copy-file-task-icon.svg';
import SftpOperationCopyFileToS3TaskIcon from '../assets/sftp-operation-copy-file-to-s3-task-icon.svg';
import SftpOperationDeleteFileTaskIcon from '../assets/sftp-operation-delete-file-task-icon.svg';
import SftpOperationDirectoryListingTaskIcon from '../assets/sftp-operation-directory-listing-task-icon.svg';
import SftpOperationMoveFileTaskIcon from '../assets/sftp-operation-move-file-task-icon.svg';
import SleepIcon from '../assets/sleep-command-icon.svg';
import SqlServerIcon from '../assets/sql-server-icon.svg';
import StopIcon from '../assets/stop-command-icon.svg';
import StopIfZeroIcon from '../assets/stop-if-zero-command-icon.svg';
import TextReaderFormatIcon from '../assets/text-reader-format-icon.svg';
import TextWriterFormatIcon from '../assets/text-writer-format-icon.svg';
import UpdateIcon from '../assets/update-command-icon.svg';
import UpdateDatarameIcon from '../assets/update-data-frame-icon.svg';
import ValidateIcon from '../assets/validate-command-icon.svg';
import XmlReaderFormatIcon from '../assets/xml-reader-format-icon.svg';
import XmlWriterFormatIcon from '../assets/xml-writer-format-icon.svg';
import ZoomIcon from '../assets/zoom-icon.svg';
import { NODE_TYPES } from './node-types';

export const ICON_MAPPER = {
  // amazon
  [NODE_TYPES['amazonRDSReader']]: AmazonRDSIcon,
  [NODE_TYPES['amazonRDSWriter']]: AmazonRDSIcon,
  [NODE_TYPES['amazonRedshiftReader']]: AmazonRedshiftIcon,
  [NODE_TYPES['amazonRedshiftWriter']]: AmazonRedshiftIcon,
  [NODE_TYPES['awsElasticsearchReader5x']]: AmazonElasticsearchIcon,
  [NODE_TYPES['s3Reader']]: AmazonS3Icon,
  [NODE_TYPES['s3Writer']]: AmazonS3Icon,
  [NODE_TYPES['amazonSESConnector']]: AmazonSESConnectorIcon,
  // anthology
  [NODE_TYPES['anthologyReader']]: AnthologyIcon,
  [NODE_TYPES['anthologyWriter']]: AnthologyIcon,
  // blackboard
  [NODE_TYPES['blackboardReader']]: BlackboardIcon,
  [NODE_TYPES['blackboardWriter']]: BlackboardIcon,
  // brightspace
  [NODE_TYPES['brightSpaceValenceApiReader']]: BrightspaceValenceIcon,
  [NODE_TYPES['brightSpaceValenceApiWriter']]: BrightspaceValenceIcon,
  // canvas
  [NODE_TYPES['canvasReader']]: CanvasIcon,
  [NODE_TYPES['canvasWriter']]: CanvasIcon,
  [NODE_TYPES['canvasGraphQLReader']]: CanvasIcon,
  // colleague
  [NODE_TYPES['colleagueReader']]: ColleagueIcon,
  [NODE_TYPES['colleagueWriter']]: ColleagueIcon,
  // docusign
  [NODE_TYPES['docuSignReader']]: DocusignIcon,
  // edfi
  [NODE_TYPES['edfiReader']]: EdfiIcon,
  [NODE_TYPES['edfiWriter']]: EdfiIcon,
  // edready
  [NODE_TYPES['edReadyReader']]: EdreadyIcon,
  // element451
  [NODE_TYPES['element451Reader']]: Element451Icon,
  [NODE_TYPES['element451Writer']]: Element451Icon,
  // ethos
  [NODE_TYPES['ethosReader']]: EthosIcon,
  [NODE_TYPES['ethosWriter']]: EthosIcon,
  [NODE_TYPES['ethosV2AsyncReader']]: EthosIcon,
  [NODE_TYPES['ethosV2Reader']]: EthosIcon,
  [NODE_TYPES['ethosGraphQLReader']]: EthosIcon,
  // google
  [NODE_TYPES['googleBigQueryReader']]: GoogleBigQueryIcon,
  [NODE_TYPES['googleBigQueryWriter']]: GoogleBigQueryIcon,
  [NODE_TYPES['googleSpreadsheetReader']]: GoogleSpreadsheetIcon,
  [NODE_TYPES['googleSpreadsheetWriter']]: GoogleSpreadsheetIcon,
  // graphql
  [NODE_TYPES['graphqlReader']]: GraphqlIcon,
  // http
  [NODE_TYPES['httpReader']]: HttpIcon,
  [NODE_TYPES['httpWriter']]: HttpIcon,
  [NODE_TYPES['httpV2Reader']]: HttpIcon,
  [NODE_TYPES['httpXmlConnector']]: HttpXmlIcon,
  // infosilem
  [NODE_TYPES['infosilemReader']]: InfosilemIcon,
  // lingk
  [NODE_TYPES['lingkAdapterReader']]: LingkIcon,
  [NODE_TYPES['lingkAdapterWriter']]: LingkIcon,
  [NODE_TYPES['lingkWriter']]: LingkIcon,
  // jdbc
  [NODE_TYPES['jdbcReader']]: JdbcIcon,
  [NODE_TYPES['jdbcWriter']]: JdbcIcon,
  // json
  [NODE_TYPES['json']]: JsonIcon,
  // leadsquared
  [NODE_TYPES['leadSquaredReader']]: LeadSquaredIcon,
  [NODE_TYPES['leadSquaredWriter']]: LeadSquaredIcon,
  // learningstream
  [NODE_TYPES['learningStreamReader']]: LearningStreamIcon,
  [NODE_TYPES['learningStreamWriter']]: LearningStreamIcon,
  // localfile
  [NODE_TYPES['localFileReader']]: LocalFileIcon,
  [NODE_TYPES['localFileWriter']]: LocalFileIcon,
  [NODE_TYPES['localFileImporter']]: LocalFileIcon,
  // log
  [NODE_TYPES['logReader']]: LogIcon,
  // microsoft
  [NODE_TYPES['microsoftCosmosDbReader']]: MicrosoftCosmosDbIcon,
  [NODE_TYPES['microsoftCosmosDbV2Reader']]: MicrosoftCosmosDbIcon,
  // moodle
  [NODE_TYPES['moodleReader']]: MoodleIcon,
  [NODE_TYPES['moodleWriter']]: MoodleIcon,
  // odata
  [NODE_TYPES['oDataReader']]: OdataIcon,
  // paycom
  [NODE_TYPES['paycomReader']]: PaycomIcon,
  [NODE_TYPES['paycomWriter']]: PaycomIcon,
  // peoplesoft
  [NODE_TYPES['peoplesoftReader']]: PeoplesoftIcon,
  [NODE_TYPES['peoplesoftWriter']]: PeoplesoftIcon,
  // salesforce
  [NODE_TYPES['salesforceBulkReader']]: SalesforceIcon,
  [NODE_TYPES['salesforceBulkWriter']]: SalesforceIcon,
  [NODE_TYPES['salesforceReader']]: SalesforceIcon,
  [NODE_TYPES['salesforceWriter']]: SalesforceIcon,
  [NODE_TYPES['salesforceV2Reader']]: SalesforceIcon,
  // sftp
  [NODE_TYPES['sftpReader']]: SftpIcon,
  [NODE_TYPES['sftpWriter']]: SftpIcon,
  // sql
  [NODE_TYPES['sqlServer']]: SqlServerIcon,
  // zoom
  [NODE_TYPES['zoomReader']]: ZoomIcon,
  [NODE_TYPES['zoomWriter']]: ZoomIcon,
  [NODE_TYPES['zoomGraphQLReader']]: ZoomIcon,

  // ----- Formats -----
  [NODE_TYPES['delimitedReader']]: DelimitedReaderFormatIcon,
  [NODE_TYPES['delimitedWriter']]: DelimitedWriterFormatIcon,
  [NODE_TYPES['excelReader']]: ExcelReaderFormatIcon,
  [NODE_TYPES['excelWriter']]: ExcelWriterFormatIcon,
  [NODE_TYPES['jsonReader']]: JsonReaderFormatIcon,
  [NODE_TYPES['textReader']]: TextReaderFormatIcon,
  [NODE_TYPES['textWriter']]: TextWriterFormatIcon,
  [NODE_TYPES['xmlReader']]: XmlReaderFormatIcon,
  [NODE_TYPES['xmlWriter']]: XmlWriterFormatIcon,

  // ----- Tasks -----
  [NODE_TYPES['dataOperationbatch']]: DataOperationBatchTaskIcon,
  [NODE_TYPES['dataOperationdedup']]: DataOperationDedupTaskIcon,
  [NODE_TYPES['fileOperationappend']]: FileOperationAppendTaskIcon,
  [NODE_TYPES['fileOperationdeleteFileFromS3']]: FileOperationDeleteFileFromS3TaskIcon,
  [NODE_TYPES['fileOperations3DirectoryList']]: FileOperationS3DirectoryListingIcon,
  [NODE_TYPES['sftpOperationcopyFile']]: SftpOperationCopyFileTaskIcon,
  [NODE_TYPES['sftpOperationcopyFileToS3']]: SftpOperationCopyFileToS3TaskIcon,
  [NODE_TYPES['sftpOperationdeleteFile']]: SftpOperationDeleteFileTaskIcon,
  [NODE_TYPES['sftpOperationdirectoryList']]: SftpOperationDirectoryListingTaskIcon,
  [NODE_TYPES['sftpOperationmoveFile']]: SftpOperationMoveFileTaskIcon,

  // ----- Commands -----
  [NODE_TYPES['deleteCommand']]: DeleteIcon,
  [NODE_TYPES['executeCommand']]: ExecuteIcon,
  [NODE_TYPES['insertCommand']]: InsertIcon,
  [NODE_TYPES['printCommand']]: PrintIcon,
  [NODE_TYPES['printSchemaCommand']]: PrintSchemaIcon,
  [NODE_TYPES['refreshCommand']]: RefreshIcon,
  [NODE_TYPES['selectCommand']]: SelectIcon,
  [NODE_TYPES['sleepCommand']]: SleepIcon,
  [NODE_TYPES['stopCommand']]: StopIcon,
  [NODE_TYPES['stopifzeroCommand']]: StopIfZeroIcon,
  [NODE_TYPES['updateCommand']]: UpdateIcon,
  [NODE_TYPES['validateCommand']]: ValidateIcon,
  // ----- Data Frame -----
  [NODE_TYPES['insert']]: InsertDatarameIcon,
  [NODE_TYPES['select']]: SelectDatarameIcon,
  [NODE_TYPES['update']]: UpdateDatarameIcon,
};
